import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TmDeliveryZoneService extends ApiService {

    index(params: any): Observable<any> {
        return super.get('/tm-delivery-zones', params);
    }

    store(body: any) {
        return super.post(`/tm-delivery-zones`, body);
    }

    edit(tmDeliveryZoneId: number) {
        return super.get(`/tm-delivery-zones/${tmDeliveryZoneId}/edit`);
    }

    update(tmDeliveryZoneId: number, body: any) {
        return super.put(`/tm-delivery-zones/${tmDeliveryZoneId}`, body);
    }

    destroy(tmDeliveryZoneId: number) {
        return super.delete(`/tm-delivery-zones/${tmDeliveryZoneId}`);
    }

    select(params: any = {}) {
        return super.get(`/tm-delivery-zones/select`, params);
    }
}
